
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthLoadingSpinner from './AuthLoadingSpinner';

const ProtectedRoute = ({ children, requireCompleteProfile = false }) => {
  const { 
    user, 
    userProfile, 
    initializing, 
    profileLoading, 
    isAuthenticated, 
    isProfileComplete 
  } = useAuth();
  const location = useLocation();

 
  if (initializing) {
    return (
      <AuthLoadingSpinner 
        message="Checking authentication..." 
        showLogo={false}
        size="small"
      />
    );
  }

 
  if (isAuthenticated() && profileLoading) {
    return (
      <AuthLoadingSpinner 
        message="Loading your profile..." 
        showLogo={false}
        size="small"
      />
    );
  }


  if (!isAuthenticated()) {
    return (
      <Navigate 
        to="/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  
  if (requireCompleteProfile && !isProfileComplete()) {
    return (
      <Navigate 
        to="/complete-profile" 
        state={{ from: location }} 
        replace 
      />
    );
  }


  return children;
};

export default ProtectedRoute;